import { css } from 'emotion';

import { colors, icons } from '@cobliteam/base-components';

export const listItem = css`
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  /* cursor: pointer; */

  & > :not(:first-child) {
    margin-top: 10px;
  }

  &:hover {
    background-color: ${colors.custom.lightestGray50};
  }
`;

export const listItemRow = css`
  position: relative;
  display: block;
  word-break: break-word;
`;

export const inputLabel = css`
  display: inline;
  margin-right: 5px;
`;

export const descriptionList = css`
  display: inline;
`;

export const unpluggedIcon = css`
  height: ${icons.size.small};
  width: ${icons.size.small};
  background-color: ${colors.custom.warning15};
  color: ${colors.warning.default};
  border-radius: 50%;
  padding: 5px;
  position: absolute;
  left: 215px;
  top: 50%;
  transform: translateY(-50%);
  box-sizing: content-box;
`;
